import "./styles.scss";

const CustomTooltip = ({ value }: { value: any }) => (
  <div className="tooltip-container">
    <span className="geos-name">{value}</span>
    <span className="tooltip-text">{value}</span>
  </div>
);
export default CustomTooltip;
